import { render, staticRenderFns } from "./CustomerDepHead.vue?vue&type=template&id=78f12015&scoped=true&"
import script from "./CustomerDepHead.vue?vue&type=script&lang=js&"
export * from "./CustomerDepHead.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=78f12015&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f12015",
  null
  
)

export default component.exports